import Vue from "vue";
import {Constructor} from "../../../global/constructor";
import {Hash} from "../../interfaces/hashInterfaces";
import {ObjectHelper} from "../../helpers/objectHelper";
import ElementHandler from "../../services/elementHandler";
import TrackedModel from "../tracked/trackedModel";
import {ArrayHelper} from "../../helpers/arrayHelper";
import {
  IMainActionContainer,
  ISortableMainAction
} from "../../interfaces/contentManagementInterfaces";

interface IMainActionable<TMainAction>{
  rootModel: TrackedModel;
  main_actions: Hash<TMainAction>;
  _mainActionHandler: ElementHandler;
  _classKey: string;
}

export default function MainActionable<TBase extends
  Constructor,
  TMainAction extends
      ISortableMainAction &
    TrackedModel,
  TContainer extends
      TrackedModel &
    IMainActionContainer<TMainAction> &
    TMainAction>(Base: TBase) {
  return class extends Base implements IMainActionable<TMainAction> {
    rootModel: TrackedModel;
    main_actions: Hash<TMainAction>= {};
    _mainActionHandler: ElementHandler;
    _classKey: string;

    get classKey(): string {
      return this._classKey;
    }

    get mainActionHandler(): ElementHandler {
      return this._mainActionHandler;
    }

    get mainActionsArray(): TMainAction[] {
      return ObjectHelper.toArray(this.main_actions)
        .sort((a, b) => a.sort_order - b.sort_order);
    }

    get hasMainActions(): boolean {
      return this.mainActionsArray.length > 0;
    }

    get lastMainActionInSortOrder(): TMainAction {
      return ArrayHelper.last(this.mainActionsArray);
    }

    initializeEmbedded(parent: TContainer, item: TMainAction , position: number, json: object = {}) {
      parent.trackCreationDeletion(item.client_id, null, item.asJson(), item);
      item.addToRepo();
      item.select();

      Vue.set(parent[item.rootName], item.client_id, item);
      return item;
    }
  }
}